<template>
	<div class="banner">
		<div class="content_box">
			<h1 class="punctuation">“</h1>
			<h1 class="title">给我一次邂逅</h1>
			<h1 class="sub_title"><span>还您 “视” 界清新！</span></h1>
			<div class="circles"><i></i></div>
		</div>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style scoped>
	.banner{ position: relative;height: 400px;background-image: url(../../../../assets/about_us_banner.png);background-repeat: no-repeat;background-position: center center; }
	.banner .content_box{ width: 966px;margin: 0 auto;padding: 50px 0 0 0; }
	.banner .punctuation{ font-size: 100px;color: #fff; }
	.banner .title{ font-size: 20px;color: #fff;line-height: 34px; }
	.banner .sub_title{ position: relative;margin-top: 6px;font-size: 30px;color: #fff;line-height: 30px; }
	.banner .sub_title::before{ content: "";display: block;position: absolute;z-index: 5;width: 280px;height: 11px;bottom: 0;left: 0;background: #ffb805; }
	.banner .sub_title span{ display: inline-block;position: relative;z-index: 9; }
	.banner .circles{ margin-top: 70px; }
	.banner .circles i{ display: inline-block;width: 46px;height: 26px;background-image: url(../../../../assets/circles_2.png);vertical-align: top; }
</style>
